import { numeral } from '../numeral';
numeral.register('format', 'ordinal', {
    regexps: {
        format: /(o)/
    },
    format(value, format, roundingFunction) {
        const locale = numeral.locales[numeral.options.currentLocale];
        let ordinal = numeral.formats.includes(' o') ? ' ' : '';
        format = format.replace(/\s?o/, '');
        ordinal += locale.ordinal(value);
        const output = numeral._.numberToFormat(value, format, roundingFunction);
        return output + ordinal;
    }
});
